<div id="viewMode">
  <form [formGroup]="viewModeForm">
    Show:
    <input type="radio" id="radMap" value="map" name="viewMode" formControlName="viewMode" (change)="viewModeChange($event)" /><label class="ml-2 mr-2" for="radMap">Map</label>
    <input type="radio" id="radTable" value="table" name="viewMode" formControlName="viewMode"  (change)="viewModeChange($event)" /><label class="ml-2 mr-2" for="radTable">Table</label>
    <input type="radio" id="radBoth" value="both" name="viewMode" formControlName="viewMode"  (change)="viewModeChange($event)" checked="checked" /><label class="ml-2" for="radBoth">Both</label>
  </form>
</div>
<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="flex-grow-1">
  <div class="row summary-row">
    <div class="col-12">
      <app-summary-totals [summaryData]="summaryData"></app-summary-totals>
    </div>
  </div>
  <div class="row flex-grow-1">
    <div [ngClass]="{'col-md-5 col-12 pr-1 flex-grow-1 d-flex flex-column' : showMode === 'both', 'd-none' : showMode === 'table', 'col-md-12 col-12 pr-1 flex-grow-1 d-flex flex-column' : showMode === 'map' }">
      <div class="card-header map-card-header mb-1">
        @if (locationTypesDisplay.length > 4) {
          <button appPopover
            [popoverTitle]="'Map Key'"
            [popoverTemplate]="popoverTemplate"
            popoverPosition="left" class="btn btn-sm btn-dark-lt ml-auto">
            Map Key
          </button>
        }
      </div>
      <div appSetHeight class="map">
        <div class="map-container">
          <div class="map-frame" #mapdiv>
            <div id="map"></div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="{'col-md-7 col-12 pl-1 flex-grow-1 d-flex flex-column' : showMode === 'both', 'd-none' : showMode === 'map', 'col-md-12 col-12 pl-1 flex-grow-1 d-flex flex-column' : showMode === 'table' }">
      <div class="row pt-2">
        <div [ngClass]="{'col-12' : showMode !== 'table', 'col-10 offset-2' : showMode === 'table' }">
          <mat-form-field appearance="fill" [hidden]="!selectedRegionId && !hasMultipleRegions" style="width: 12%" subscriptSizing="dynamic">
            <mat-label>Region</mat-label>
            <mat-select [(value)]="selectedRegionId" (selectionChange)="regionChange($event.value)">
              <mat-option>None</mat-option>
              @for (region of regionList; track region) {
                <mat-option [value]="region.id">{{region.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" [hidden]="!selectedRegionId && !selectedDepotId && !hasMultipleDepots" style="width: 15%" subscriptSizing="dynamic">
            <mat-label>Depot</mat-label>
            <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)">
              <mat-option>None</mat-option>
              @for (depot of depotList; track depot) {
                <mat-option [value]="depot.id">{{depot.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 15%" subscriptSizing="dynamic">
            <mat-label>Location type</mat-label>
            <mat-select [(value)]="selectedAssetLocationTypeId" (selectionChange)="locationTypeChange($event.value)">
              <mat-option>None</mat-option>
              @for (loccationType of locationTypeList; track loccationType) {
                <mat-option [value]="loccationType.id">{{loccationType.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 15%" subscriptSizing="dynamic">
            <mat-label>Location</mat-label>
            <mat-select [(value)]="selectedAssetLocationId" (selectionChange)="locationChange($event.value)">
              <mat-option>None</mat-option>
              @for (location of getLocationsList(); track location) {
                <mat-option [value]="location.id">{{location.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 10%" subscriptSizing="dynamic">
            <mat-label>Type</mat-label>
            <mat-select [(value)]="selectedAssetTypeId" (selectionChange)="assetTypeChange($event.value)">
              <mat-option>None</mat-option>
              @for (asset of assetTypeList; track asset) {
                <mat-option [value]="asset.id">{{asset.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="fill" style="width: 21%" subscriptSizing="dynamic">
            <mat-label>Search</mat-label>
            <input type="text"
              aria-label="Number"
              matInput
              [formControl]="searchControl"
              [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" panelWidth="auto">
                @for (option of filteredLocations | async; track option) {
                  <mat-option [value]="option.displayName" (onSelectionChange)="onLocationSelect(option)">
                    {{option.displayName}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div appSetHeight class="col-12 pl-0 pr-0 flex-grow-1" subscriptSizing="dynamic">
          <div class="h-100 overflow-auto">
            @if (currentMode == InventryMode.Summary || currentMode == InventryMode.GroupedSummary) {
              <div class="col-12 summary pl-0">
                <div class="card mt-2">
                  <div class="card-header">
                    <div class="card-header-title mb-1 mb-md-0">
                      Summary Table
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-sm card-table table-nowrap">
                      <thead>
                        <tr>
                          <th class="type">
                            <div class="pl-1">Type</div>
                            <div class="font-weight-bold totalCount">&nbsp;</div>
                          </th>
                          <th class="text-center">
                            <div>Customer</div>
                            <div class="font-weight-bold totalCount">{{ totalCustomerCount }}</div></th>
                            <th class="text-center">
                              <div>Depot</div>
                              <div class="font-weight-bold totalCount">{{ totalDepotCount }}</div></th>
                              <th class="text-center">
                                <div>Other</div>
                                <div class="font-weight-bold totalCount">{{ totalOtherCount }}</div></th>
                                <th class="text-center">
                                  <div>On Move</div>
                                  <div class="font-weight-bold totalCount">{{ totalOnMoveCount }}</div></th>
                                  <th class="text-center">
                                    <div>Damaged</div>
                                    <div class="font-weight-bold totalCount">{{ totalDamagedCount }}</div></th>
                                    <th class="text-center">
                                      <div>Available</div>
                                      <div class="font-weight-bold totalCount">{{ totalSurplus }}</div></th>
                                      <th class="text-center">
                                        <div class="total">Total</div>
                                        <div class="font-weight-bold totalCount">{{ totalTotal }}</div></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @if (roroSummary.length > 0) {
                                        <tr>
                                          <td colspan="8" class="pl-2"><b>RoRo</b></td>
                                        </tr>
                                      }
                                      @for (item of roroSummary; track item) {
                                        <tr>
                                          <td class="type" (click)="toggleRoroSummaryRow(item.Type)" title="Expand" class="controls clickable"><div class="type">@if (!openRoroTypes.includes(item.Type)) {
                                            <i class="material-icons">add</i>
                                            }@if (openRoroTypes.includes(item.Type)) {
                                            <i class="material-icons">remove</i>
                                          } {{ item.Type }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.CustomerCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.DepotCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.OtherCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.OnMoveCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.DamagedCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.getSurplus() }}</div></td>
                                          <td class="text-center count total"><div class="count"><b>{{ item.getTotal() }}</b></div></td>
                                        </tr>
                                        @for (child of item.Children; track child) {
                                          @if (openRoroTypes.includes(item.Type)) {
                                            <tr>
                                              <td class="type"><div class="type pl-5">{{ child.Type }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.CustomerCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.DepotCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.OtherCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.OnMoveCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.DamagedCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.getSurplus() }}</div></td>
                                              <td class="text-center count total"><div class="count"><b>{{ child.getTotal() }}</b></div></td>
                                            </tr>
                                          }
                                        }
                                      }
                                    </tbody>
                                    <tbody>
                                      @if (skipsSummary.length > 0) {
                                        <tr>
                                          <td colspan="8" class="pl-2"><b>Skip</b></td>
                                        </tr>
                                      }
                                      @for (item of skipsSummary; track item) {
                                        <tr>
                                          <td class="type" (click)="toggleSkipSummaryRow(item.Type)" title="Expand" class="controls clickable"><div class="type">@if (!openSkipTypes.includes(item.Type)) {
                                            <i class="material-icons">add</i>
                                            }@if (openSkipTypes.includes(item.Type)) {
                                            <i class="material-icons">remove</i>
                                          } {{ item.Type }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.CustomerCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.DepotCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.OtherCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.OnMoveCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.DamagedCount }}</div></td>
                                          <td class="text-center count"><div class="count">{{ item.getSurplus() }}</div></td>
                                          <td class="text-center count total"><div class="count"><b>{{ item.getTotal() }}</b></div></td>
                                        </tr>
                                        @for (child of item.Children; track child) {
                                          @if (openSkipTypes.includes(item.Type)) {
                                            <tr>
                                              <td class="type"><div class="type pl-5">{{ child.Type }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.CustomerCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.DepotCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.OtherCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.OnMoveCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.DamagedCount }}</div></td>
                                              <td class="text-center count"><div class="count">{{ child.getSurplus() }}</div></td>
                                              <td class="text-center count total"><div class="count"><b>{{ child.getTotal() }}</b></div></td>
                                            </tr>
                                          }
                                        }
                                      }
                                    </tbody>
                                    <tbody class="list">
                                      <tr>
                                        <td class="h-2" colspan="8"></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          }

                          @if (currentMode == InventryMode.NotDepot) {
                            <div class="col-12 inventory pl-0">
                              <div class="table-responsive mt-2">
                                <table class="table table-sm card-table" aria-labelledby="tableLabel">
                                  <thead>
                                    <tr class="assets-header-row">
                                      <th class="exp-ctrl"></th>
                                      <th class="type location">Location</th>
                                      <th class="text-center">
                                        <div class="count">Total</div>
                                        <div class="font-weight-bold totalCountSide">{{ getTotal() }}</div>
                                      </th>
                                      @for (item of assetSummaryAssetTypes; track item) {
                                        <th [title]="item.AssetType" class="text-center">
                                          <div class="count">{{item.AssetType}}</div>
                                          <div class="font-weight-bold totalCountSide">{{ getAssetTypeTotal(item.AssetType) }}</div>
                                        </th>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (item of assetSummaryData; track item) {
                                      <tr class="master-row">
                                        <td class="exp-ctrl">
                                          <div (click)="toggleRow(item.LocationId)" title="Expand" class="controls clickable">@if (!openLocations.includes(item.LocationId)) {
                                            <i class="material-icons">add</i>
                                            }@if (openLocations.includes(item.LocationId)) {
                                            <i class="material-icons">remove</i>
                                          }</div>
                                        </td>
                                        <td class="type location" [title]="item.LocationName">
                                          <div (click)="goToLocation(item.LocationId)" class="location clickable locationName w-100">{{ item.LocationName }}</div>
                                        </td>
                                        <td class="text-center count">{{ item.getTotal() }}</td>
                                        @for (typeItem of assetSummaryAssetTypes; track typeItem) {
                                          <td class="text-center count">
                                            {{ item.getTypeCountDisplay(typeItem.AssetType) }}
                                          </td>
                                        }
                                      </tr>
                                      @if (openLocations.includes(item.LocationId)) {
                                        @for (asset of item.Assets; track asset) {
                                          <tr>
                                            <td class="exp-ctrl"></td>
                                            <td class="location asset"><div class="pl-5">{{ asset.id }}</div></td>
                                            <td></td>
                                            @for (typeItem of assetSummaryAssetTypes; track typeItem) {
                                              <td class="text-center">
                                                @if (typeItem.AssetType == asset.assetType) {
                                                  <span>1</span>
                                                }
                                              </td>
                                            }
                                            <td></td>
                                          </tr>
                                        }
                                      }
                                    }
                                  </tbody>
                                  <tbody class="list">
                                    <tr>
                                      <td class="h-2" colspan="8"></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          }

                          @if (currentMode == InventryMode.Depot) {
                            <div class="col-12 inventory pl-0">
                              <div class="table-responsive mt-2">
                                <table class="table table-sm card-table">
                                  <thead>
                                    <tr><td class="font-weight-bold"><div class="summary">Depot Summary</div></td><td></td><td></td><td></td><td></td></tr>
                                  </thead>
                                  <thead>
                                    <tr><td></td><td></td><td></td><td></td><td></td></tr>
                                  </thead>
                                  <thead>
                                    <tr>
                                      <th class="type">
                                        <div class="pl-1">Type</div>
                                        <div class="font-weight-bold totalCount">&nbsp;</div>
                                      </th>
                                      <th class="text-center">
                                        <div class="depot">Total Containers</div>
                                        <div class="font-weight-bold totalCount">{{ filteredAssets.length }}</div></th>
                                        <th class="text-center">
                                          <div class="depot">Damaged</div>
                                          <div class="font-weight-bold totalCount">{{ filteredAssetsDamaged().length }}</div></th>
                                          <th class="text-center">
                                            <div class="depot">Yard</div>
                                            <div class="font-weight-bold totalCount">{{ getYardTotal() }}</div></th>
                                            <th class="text-center">
                                              <div class="depot">Available</div>
                                              <div class="font-weight-bold totalCount">{{ filteredAssetsSurplus() }}</div></th>
                                            </tr>
                                          </thead>
                                          @if (roroContainerGroupSummary.Groups && roroContainerGroupSummary.Groups.length > 0) {
                                            <thead>
                                              <tr><td class="group">RoRo</td><td></td><td></td><td></td><td></td></tr>
                                            </thead>
                                            <tbody>
                                              @for (group of roroContainerGroupSummary.Groups; track group) {
                                                <tr>
                                                  <td class="type" (click)="toggleRoroSummaryRow(group.Group.name)" title="Expand" class="controls clickable"><div class="type">@if (!openRoroTypes.includes(group.Group.name)) {
                                                    <i class="material-icons">add</i>
                                                    }@if (openRoroTypes.includes(group.Group.name)) {
                                                    <i class="material-icons">remove</i>
                                                  } {{ group.Group.name }}</div></td>
                                                  <td class="text-center">{{ group.getTypeCount(filteredAssets) }}</td>
                                                  <td class="text-center">{{ group.getTypeDamagedCount(filteredAssets) }}</td>
                                                  <td class="text-center">{{ group.getTypeYardCount(filteredAssets) }}</td>
                                                  <td class="text-center">{{ group.getTypeSurplusCount(filteredAssets) }}</td>
                                                </tr>
                                                @for (typeItem of group.Summary; track typeItem) {
                                                  @if (openRoroTypes.includes(group.Group.name)) {
                                                    <tr>
                                                      <td class="text-center">{{ typeItem.AssetType }}</td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeCount(filteredAssets) }}</div></td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeDamagedCount(filteredAssets) }}</div></td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeYardCount(filteredAssets) }}</div></td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeSurplusCount(filteredAssets) }}</div></td>
                                                    </tr>
                                                  }
                                                }
                                              }
                                            </tbody>
                                            <tbody class="list">
                                              <tr>
                                                <td class="h-2" colspan="8"></td>
                                              </tr>
                                            </tbody>
                                          }
                                          @if (skipContainerGroupSummary.Groups && skipContainerGroupSummary.Groups.length > 0) {
                                            <thead>
                                              <tr><td class="group">Skip</td><td></td><td></td><td></td><td></td></tr>
                                            </thead>
                                            <tbody>
                                              @for (group of skipContainerGroupSummary.Groups; track group) {
                                                <tr>
                                                  <td class="type" (click)="toggleSkipSummaryRow(group.Group.name)" title="Expand" class="controls clickable"><div class="type">@if (!openSkipTypes.includes(group.Group.name)) {
                                                    <i class="material-icons">add</i>
                                                    }@if (openSkipTypes.includes(group.Group.name)) {
                                                    <i class="material-icons">remove</i>
                                                  } {{ group.Group.name }}</div></td>
                                                  <td class="text-center">{{ group.getTypeCount(filteredAssets) }}</td>
                                                  <td class="text-center">{{ group.getTypeDamagedCount(filteredAssets) }}</td>
                                                  <td class="text-center">{{ group.getTypeYardCount(filteredAssets) }}</td>
                                                  <td class="text-center">{{ group.getTypeSurplusCount(filteredAssets) }}</td>
                                                </tr>
                                                @for (typeItem of group.Summary; track typeItem) {
                                                  @if (openSkipTypes.includes(group.Group.name)) {
                                                    <tr>
                                                      <td class="text-center">{{ typeItem.AssetType }}</td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeCount(filteredAssets) }}</div></td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeDamagedCount(filteredAssets) }}</div></td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeYardCount(filteredAssets) }}</div></td>
                                                      <td class="text-center"><div class="count">{{ typeItem.getTypeSurplusCount(filteredAssets) }}</div></td>
                                                    </tr>
                                                  }
                                                }
                                              }
                                            </tbody>
                                            <tbody class="list">
                                              <tr>
                                                <td class="h-2" colspan="8"></td>
                                              </tr>
                                            </tbody>
                                          }
                                        </table>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <ng-template #popoverTemplate>
                            <ul class="list-unstyled">
                              @for (type of locationTypesDisplay; track type) {
                                <li>
                                  <div class="pr-2">
                                    <div class="icon-circle icon-circle-xs map-legend dot" [ngStyle]="{'background-color': type.colour}"></div>
                                    {{ type.name }}
                                  </div>
                                </li>
                              }
                            </ul>
                          </ng-template>